import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
//import VueApollo from 'vue-apollo'
import './registerServiceWorker'
import router from './router'
//import { createProvider } from './vue-apollo'



Vue.config.productionTip = false

//Vue.use(VueApollo)
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    count: 0,
    currentset: '',
    sets: [],
    needlists: []
  },
  mutations: {
    setcurrentset(state, nr) {
      state.currentset = nr;
    },
    importsets (state, sets) {
        console.log(sets);
        state.sets = JSON.parse(sets) 
    },
    addset (state, set) {
      console.log(set);
      if ( state.sets.find(el => el.nr === set.nr) === undefined ) {
        state.sets.push(set);
        localStorage.setItem('setlist', JSON.stringify(state.sets)); 
      }
  },
  increment (state) {
      state.count++
    }
  }
})


new Vue({
  router,
  store: store,
  //apolloProvider: createProvider(),
  render: h => h(App)
}).$mount('#app')
